/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect } from 'react';
import {
  Link,
  ToastTrigger,
  Toast,
  ToastTitle,
  ToastBody,
  ToastFooter,
  useId,
  Button,
} from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';
import { useToast } from '@bingads-webui-fluent-component/toast-provider';

const timeout = 10000;

const ToastComponent = ({
  i18n, count, navigation, logger, dismissToast, toastId,
}) => {
  const buttonRef = React.createRef<HTMLButtonElement>();

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [buttonRef]);

  return (
    <Toast >
      <ToastTitle
        action={
          <ToastTrigger>
            <Button
              className="close-button"
              appearance="subtle"
              icon={<Dismiss20Regular />}
              title={i18n.getString(_TL_('Dismiss'))}
              aria-label={i18n.getString(_TL_('Dismiss'))}
              ref={buttonRef}
            />
          </ToastTrigger>
            }
      >{i18n.getString(_TL_('Display assets saved'))}
      </ToastTitle>
      {
          count === 1 ?
            <ToastBody >{i18n.getString(_TL_('Your template was successfully saved. Do you want to create a new campaign for Display ads?'))}</ToastBody> :
            <ToastBody >{i18n.getString(_TL_('Your template was successfully saved. All {{count}} sizes are ready for you to use. Do you want to create a new campaign for Display ads?'), {
            count,
          })}
            </ToastBody>
          }
      <ToastFooter>
        <Link
          className="ads-studio-create-campaign-link"
          href="/campaign/vnext/createcampaign/displayplusdisplay"
          onClick={(ev) => {
              ev.preventDefault();
              navigation.gotoCampaignUIPage({ subpath: 'createcampaign/displayplusdisplay' });
              // manually dismiss the toast as we have prevented the default action
              dismissToast(toastId);
              if (logger) {
                logger.logTrace('[display template] create campaign link clicked');
              }
            }}
        >{i18n.getString(_TL_('Create campaign'))}
        </Link>
      </ToastFooter>
    </Toast>);
};

export const useNotify = ({
  i18n,
  count,
  navigation,
  logger,
}) => {
  const toastId = useId('notify-toast');
  const { dispatchToast, dismissToast } = useToast();

  const notify = useCallback(() =>
    dispatchToast(
      <ToastComponent
        i18n={i18n}
        count={count}
        navigation={navigation}
        logger={logger}
        toastId={toastId}
        dismissToast={dismissToast}
      />,
      {
        intent: 'success', toastId, timeout, politeness: 'assertive',
      }
    ), [i18n, navigation, count, toastId, logger, dismissToast, dispatchToast]);

  return notify;
};
